<template>
  <div class="pathMap">
    <el-row class="pathBtn">
      <el-button
        type="primary"
        v-if="hasPerm('base:station:addr:review')"
        @click.native="auditPathBtn"
        >审核</el-button
      >
      <el-button @click.native="gotoPathList">返回</el-button>
    </el-row>
    <el-row class="main">
      <div class="imgList">
        <el-row class="time">{{ userData.addTime }}</el-row>
        <el-row class="userMess"
          >{{ userData.personnelName }}（{{ userData.plate }}）</el-row
        >
        <el-row
          class="imgItem"
          @click.native="openImgWindow(item, index)"
          v-for="(item, index) in userData.addrImages"
          :class="{ active: isActive == index }"
          :key="index"
        >
          <span class="sortIndex">{{ item.sort }}</span>
          <el-image
            v-if="judgeImg(item.url)"
            class="imgBox"
            :src="item.url"
            fit="cover"
          >
          </el-image>
          <template v-else>
            <video
              :src="item.url"
              preload
              class="videoBox"
              width="150"
              height="110"
            ></video>
            <i class="iconfont iconshipinbofang"></i>
          </template>
        </el-row>
      </div>
      <div id="mapBox" class="mapWrapper"></div>
    </el-row>

    <el-row class="infoWindow" ref="pathInfowindow" v-show="pathId">
      <el-row class="imgBox" style="width: 150px; height: 110px" v-if="isImg">
        <el-image :src="pathInfowindowData.url" :preview-src-list="previewArr">
        </el-image>
      </el-row>
      <el-row class="videoBox" v-else @click.native="openVideo">
        <video
          ref="videoPlayer"
          preload
          width="150"
          height="110"
          :src="pathInfowindowData.url"
        ></video>
        <i class="iconfont iconshipinbofang"></i>
      </el-row>
      <el-row class="desc">{{ pathInfowindowData.remark }}</el-row>
    </el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      class="videoDialog"
      width="0px"
    >
      <video
        height="750"
        fit="cover"
        controls
        autoplay
        duration
        paused
        ref="videoPlayerBig"
        id="videoPlayerBig"
        :src="pathInfowindowData.url"
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  name: "Audit",
  prop: {},
  data() {
    return {
      dialogWidth: null,
      dialogVisible: false,
      isImg: true,
      id: null,
      stationCode: null,
      map: null,
      marker: null,
      pathMarker: null,
      pathIcon: null,
      infoWindow: null,
      switch: true,
      pathSwitch: true,
      pathId: false,
      isActive: 0,
      previewArr: [],
      addrId: null,
      // pathImgList:[],
      pathInfowindow: null, // 基站信息窗体
      pathInfowindowData: {},
      userData: {},
      scale: null,
    };
  },
  created() {
    this.id = this.$route.params.id || sessionStorage.getItem("id");
    this.stationCode =
      this.$route.params.stationCode || sessionStorage.getItem("stationCode");
    sessionStorage.setItem("stationCode", this.stationCode);
    sessionStorage.setItem("id", this.id);
  },
  mounted() {
    this.init();
    this.checkPathImg();
  },
  methods: {
    openVideo() {
      this.dialogVisible = true;
    },
    gotoPathList() {
      this.$router.push("/PathAudit");
    },
    judgeImg(url) {
      let str = url.split(".").pop();
      if (str == "mp4") {
        return false;
      } else {
        return true;
      }
    },
    //  审核路径
    auditPathBtn() {
      this.$confirm("请确定审核结果", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "通过",
        cancelButtonText: "不通过",
      })
        .then(() => {
          this.auditPath(2);
        })
        .catch((action) => {
          if (action === "cancel") {
            this.auditPath(3);
          } else {
            return;
          }
        });
    },
    async auditPath(review) {
      let _this = this;
      let form = new FormData();
      // 文件对象
      form.append("addrId", this.addrId);
      form.append("review", review);
      let { data: res } = await _this.$axios.patch(
        "/api/base/station/addr/review",
        form
      );
      if (res.code == 1) {
        _this.$message.success("审核成功");
        _this.$router.push("/PathAudit");
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查看站址路径的图片信息
    async checkPathImg() {
      this.addrId = this.id;
      this.tablist = false;
      this.$nextTick(() => {
        this.getStationLocal(this.stationCode);
      });
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/addr/scheme/" + this.id
      );
      if (res.code == 1) {
        this.userData = res.data;
        // this.pathImgList=res.data.addrImages
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查看基站定位
    async getStationLocal(code) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/base/station/gps/location?code=" + code
      );
      if (res.code == 1) {
        if (_this.marker) {
          _this.map.remove(_this.marker);
        }
        _this.marker = new AMap.Marker({
          icon: require("@/assets/images/base-station.png"),
          anchor: "bottom-center",
          position: [res.data.longitude, res.data.latitude],
          offset: new AMap.Pixel(0, 5),
        });
        _this.map.add(_this.marker);
        _this.map.setCenter([res.data.longitude, res.data.latitude]);
        _this.marker.on("click", function () {
          var info = [];
          info.push("<p class='input-item'>" + res.data.name + "</p>");
          _this.infoWindow = new AMap.InfoWindow({
            offset: new AMap.Pixel(0, -40),
            anchor: "bottom-center",
            closeWhenClickMap: true,
            //   autoMove:true,
            content: info.join(""), //使用默认信息窗体框样式，显示信息内容
          });
          if (_this.switch) {
            _this.infoWindow.open(_this.map, [
              res.data.longitude,
              res.data.latitude,
            ]);
          } else {
            _this.infoWindow.close();
          }
          _this.switch = !_this.switch;
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 点击站址路径图片，定位到地图上
    openImgWindow(data, index) {
      if (this.pathMarker) {
        this.map.remove(this.pathMarker);
      }
      this.pathSwitch = true;
      this.$nextTick(() => {
        let _this = this;
        this.isActive = index;
        this.previewArr = [];
        this.pathId = true;
        this.previewArr.push(data.url);
        let str = data.url.split(".").pop();
        if (str == "mp4") {
          this.isImg = false;
        } else {
          this.isImg = true;
        }
        this.pathInfowindowData = data;
        this.pathMarker = new AMap.Marker({
          icon: _this.pathIcon,
          anchor: "bottom-center",
          position: [data.longitude, data.latitude], // 基点位置
          offset: new AMap.Pixel(0, 5), // 设置点标记偏移量
          map: _this.map,
        });
        this.map.add(this.pathMarker);
        this.pathInfowindow.open(this.map, [data.longitude, data.latitude]);
        this.map.setCenter([data.longitude, data.latitude]);
        this.map.setZoom(20);
        this.pathMarker.on("click", function () {
          _this.pathSwitch = !_this.pathSwitch;
          if (_this.pathSwitch) {
            _this.pathInfowindow.open(_this.map, [
              data.longitude,
              data.latitude,
            ]);
          } else {
            _this.pathInfowindow.close();
          }
        });
      });
    },
    init() {
      let _this = this;
      this.map = new AMap.Map("mapBox", {
        resizeEnable: true,
        zoom: 15,
        mapStyle: "amap://styles/fresh",
      });
      this.pathInfowindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: _this.$refs.pathInfowindow.$el,
        offset: new AMap.Pixel(2, -30),
        anchor: "bottom-center",
        // closeWhenClickMap:true,
        autoMove: true,
      });
      this.pathIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image:
          "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png",
        imageSize: new AMap.Size(25, 34),
        map: _this.map,
      });

      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });
    },
  },
  beforeDestroy() {
    sessionStorage.removeItem("stationCode");
    sessionStorage.removeItem("id");
  },
};
</script>

<style lang="scss" scoped>
.videoDialog {
  /deep/ .el-dialog {
    margin-top: 100px !important;
    .el-dialog__body {
      padding: 0px !important;
      #videoPlayerBig {
        max-width: 1000px;
        position: fixed;
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        margin: auto;
      }
    }
  }
}
/deep/ .el-image-viewer__img {
  max-width: 100% !important;
  max-height: 100% !important;
}
.pathMap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px !important;
  .main {
    width: 100%;
    height: calc(100% - 25px);
    padding-top: 20px;
    position: relative;
    .imgList {
      position: absolute;
      box-sizing: border-box;
      width: 190px;
      height: calc(100% - 50px);
      overflow: auto;
      background: #ffffff;
      padding: 10px 20px;
      z-index: 70;
      left: 15px;
      top: 35px;
      .time {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .userMess {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
      .active {
        border: 1px solid #0094ff;
      }
      .imgItem {
        box-sizing: border-box;
        width: 150px;
        height: 110px;
        margin: 10px 0 !important;
        position: relative;
        cursor: pointer;
        .sortIndex {
          position: absolute;
          left: 5px;
          top: 5px;
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          background: #fff;
          border-radius: 50%;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          z-index: 99;
        }
        .imgBox {
          width: 100%;
          height: 100%;
        }
        i {
          position: absolute;
          font-size: 35px;
          left: 54px;
          top: 34px;
          color: #fff;
        }
        i:hover {
          color: #fff;
        }
        .videoBox {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .mapWrapper {
      height: 100%;
      width: 100%;
    }
  }
  .infoWindow {
    width: 170px;
    background: #ffffff;
    border: 1px solid #999999;
    border-radius: 8px;
    padding: 5px;
    position: relative;
    cursor: pointer;
    .imgBox {
      width: 158px;
      height: 110px;
      .el-image {
        width: 158px;
        height: 110px;
      }
    }
    .videoBox {
      position: relative;
      width: 158px;
      height: 110px;
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .iconshipinbofang {
        position: absolute;
        font-size: 35px;
        left: 54px;
        top: 34px;
        color: #fff;
      }
      .iconshipinbofang:hover {
        color: #fff;
      }
    }
    .desc {
      word-wrap: break-word;
      font-size: 14px;
      line-height: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
  }
  .infoWindow:before {
    box-sizing: content-box;
    width: 0px;
    height: 0px;
    position: absolute;
    bottom: -16px;
    right: 80px;
    padding: 0;
    border-top: 8px solid #ffffff;
    border-bottom: 8px solid transparent;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    display: block;
    content: "";
    z-index: 12;
  }
  .infoWindow:after {
    box-sizing: content-box;
    width: 0px;
    height: 0px;
    position: absolute;
    bottom: -18px;
    right: 80px;
    padding: 0;
    border-top: 9px solid #999;
    border-bottom: 9px solid transparent;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    display: block;
    content: "";
    z-index: 10;
  }
}

.imgList::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.imgList::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.7);
  background: #999;
}
.imgList::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.7);
  border-radius: 2px;
  background: #ededed;
}
</style>
